module.exports = __webpack_public_path__ + "static/home-banner3-min-7d0e176055e64cd263c95f7c2cc61d16.png";